const SAMPLE_PREVIEW_LIMIT = 5;
const SAMPLE_VALUE_MAX_CHARS = 60;
function formatSample(v) {
    if (v === null || v === undefined)
        return 'null';
    const s = typeof v === 'string' ? v : JSON.stringify(v);
    return s.length > SAMPLE_VALUE_MAX_CHARS ? `${s.slice(0, SAMPLE_VALUE_MAX_CHARS)}…` : s;
}
function formatNumber(n) {
    if (n === null || n === undefined)
        return '-';
    if (n >= 1_000_000)
        return `${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000)
        return `${(n / 1_000).toFixed(1)}k`;
    return String(n);
}
function formatColumn(col) {
    const tags = [col.dataType];
    if (col.isPk)
        tags.push('PK');
    if (col.fkTarget)
        tags.push(`FK→${col.fkTarget}`);
    if (!col.isNullable)
        tags.push('NOT NULL');
    const parts = [`- ${col.columnName} (${tags.join(', ')})`];
    const stats = [];
    if (col.cardinality !== null)
        stats.push(`distinct=${formatNumber(col.cardinality)}`);
    if (col.nullCount !== null && col.nullCount > 0) {
        stats.push(`nulls=${formatNumber(col.nullCount)}`);
    }
    if (col.minValue !== null && col.maxValue !== null) {
        stats.push(`range=[${formatSample(col.minValue)}, ${formatSample(col.maxValue)}]`);
    }
    if (col.sampleValues && col.sampleValues.length > 0) {
        const samples = col.sampleValues.slice(0, SAMPLE_PREVIEW_LIMIT).map(formatSample);
        stats.push(`samples=[${samples.join(', ')}]`);
    }
    if (stats.length > 0) {
        parts.push(`  · ${stats.join(' · ')}`);
    }
    if (col.description) {
        parts.push(`  · 설명: ${col.description}`);
    }
    else if (col.sourceComment) {
        parts.push(`  · (DB 코멘트) ${col.sourceComment}`);
    }
    return parts.join('\n');
}
function formatIndex(idx) {
    const tags = [];
    if (idx.isPrimary)
        tags.push('PRIMARY');
    else if (idx.isUnique)
        tags.push('UNIQUE');
    if (idx.indexMethod)
        tags.push(idx.indexMethod);
    const tagPart = tags.length > 0 ? ` (${tags.join(' ')})` : '';
    const cols = idx.columnNames.length > 0 ? ` on (${idx.columnNames.join(', ')})` : '';
    const predicate = idx.predicate ? ` WHERE ${idx.predicate}` : '';
    return `- ${idx.indexName}${tagPart}${cols}${predicate}`;
}
/**
 * Phase 9 의 db.describe_table 툴이 LLM 컨텍스트로 그대로 전달하는 포맷.
 * 어드민 UI 의 "Skill 미리보기" 도 동일 함수를 호출해 일관성을 보장한다.
 */
export function formatTableForLlm(table, columns, indexes = []) {
    const header = `테이블 ${table.schemaName}.${table.tableName}${table.isView ? ' (뷰)' : ''} — ${columns.length}개 컬럼${table.estimatedRowCount !== null ? ` · 약 ${formatNumber(table.estimatedRowCount)}행` : ''}`;
    const lines = [header];
    if (table.description) {
        lines.push(`설명: ${table.description}`);
    }
    else if (table.sourceComment) {
        lines.push(`(DB 코멘트) ${table.sourceComment}`);
    }
    if (table.removedAt) {
        lines.push('주의: 마지막 sync 에서 발견되지 않은 테이블입니다.');
    }
    lines.push('', '컬럼:');
    for (const col of columns) {
        if (col.removedAt)
            continue;
        lines.push(formatColumn(col));
    }
    const liveIndexes = indexes.filter((i) => !i.removedAt);
    if (liveIndexes.length > 0) {
        lines.push('', '인덱스:');
        for (const idx of liveIndexes) {
            lines.push(formatIndex(idx));
        }
    }
    return lines.join('\n');
}
//# sourceMappingURL=data-source-context.js.map